import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const SynapseTheme = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#ebf3ff',
            100: '#c2deff',
            200: '#99c9ff',
            300: '#70b4ff',
            400: '#479fff',
            500: '#0966e9',
            600: '#0852c7',
            700: '#063fa5',
            800: '#052b83',
            900: '#041761',
            950: '#020b38'
        },
        colorScheme: {
            light: {
                primary: {
                    color: '#0966e9',
                    contrastColor: '#ffffff',
                    hoverColor: '#0852c7',
                    activeColor: '#063fa5'
                },
                highlight: {
                    background: '#ebf3ff',
                    focusBackground: '#c2deff',
                    color: '#0966e9',
                    focusColor: '#0852c7'
                },
                surface: {
                    0: '#ffffff',           // Blanco para modo claro
                    50: '#f8f9fa',          // Gris muy claro
                    100: '#f3f4f6',         // Gris claro
                    200: '#e5e7eb',         // Gris
                    300: '#d1d5db',         // Gris medio
                    400: '#9ca3af',         // Gris medio-oscuro
                    500: '#6b7280',         // Gris oscuro
                    600: '#4b5563',         // Gris más oscuro
                    700: '#374151',         // Gris muy oscuro
                    800: '#1f2937',         // Casi negro
                    900: '#111827',         // Muy oscuro
                    950: '#0a0a0a'          // Negro
                },
                text: {
                    color: '#111827',       // Texto oscuro para modo claro
                    hoverColor: '#0a0a0a',
                    mutedColor: '#6b7280',
                    hoverMutedColor: '#4b5563'
                }
            },
            dark: {
                primary: {
                    color: '#99c9ff',       // Azul claro para modo oscuro
                    contrastColor: '#0a0a0a',
                    hoverColor: '#70b4ff',
                    activeColor: '#479fff'
                },
                highlight: {
                    background: 'rgba(153, 201, 255, 0.16)',
                    focusBackground: 'rgba(153, 201, 255, 0.24)',
                    color: '#99c9ff',
                    focusColor: '#70b4ff'
                },
                surface: {
                    0: '#0a0a0a',           // Negro principal para modo oscuro
                    50: '#111827',          // Muy oscuro
                    100: '#1f2937',         // Oscuro
                    200: '#374151',         // Gris oscuro
                    300: '#4b5563',         // Gris medio-oscuro
                    400: '#6b7280',         // Gris medio
                    500: '#9ca3af',         // Gris claro
                    600: '#d1d5db',         // Gris muy claro
                    700: '#e5e7eb',         // Casi blanco
                    800: '#f3f4f6',         // Blanco grisáceo
                    900: '#f8f9fa',         // Blanco
                    950: '#ffffff'          // Blanco puro
                },
                text: {
                    color: '#ffffff',       // Texto blanco para modo oscuro
                    hoverColor: '#f8f9fa',
                    mutedColor: '#d1d5db',
                    hoverMutedColor: '#e5e7eb'
                }
            }
        }
    }
});

export default SynapseTheme;
